// React
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
// Constants
import { GROUP_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import RouteConstants from "../../../configs/RouteConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
import MessageContants from "../../../configs/MessageContants";
// Services
import { get, put } from "../../../services/FetchHelper";
import toast from 'react-hot-toast';
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const Groups = () => {
    const permissions = usePermissions();
    const navigate = useNavigate();
    const spinService = SpinService();
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: ""
    });

    const [groups, setGroups] = useState({
        entries: [],
        total_count: 0
    });

    const getGroups = async () => {
        spinService.on();
        const response = await get(EntityConstants.GROUPS, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}`);
        const data = await response.json();
        spinService.off();
        setGroups(data);
    };

    const onView = (row) => {
        navigate(`${RouteConstants.GROUP}/${row.id}`)
    };

    const onSwitch = async (e) => {
        spinService.on();
        const response = await put(EntityConstants.GROUPS + `/${e.id}`, { group: { status: !e.status } });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(MessageContants.GROUP_UPDATED);
            getGroups();
        }
        spinService.off();
    };

    useEffect(() => {
        if (permissions.has(PermissionConstants.GROUP_VIEW)) {
            getGroups();
        } else {
            navigate("/");
        }
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Roles
                    </Typography>
                    <Link to={RouteConstants.GROUP}>
                        {permissions.has(PermissionConstants.GROUP_CREATE) &&
                            <Button
                                variant="contained"
                                startIcon={<Iconify icon="eva:plus-fill" />}
                            >
                                New Role
                            </Button>
                        }
                    </Link>
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={GROUP_TABLE_HEADS}
                        tableDatas={groups.entries}
                        totalCount={groups.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter(filter)}
                        onView={(row) => onView(row)}
                        onSwitch={(e) => onSwitch(e)}
                    />
                </Card>
            </Container>
        </React.Fragment>
    );
};

export default Groups;
